<template>
  <VContent>
    <template slot="right">
      <span>طلبات التقديم على القروض</span>
    </template>
    <template slot="left">
      <b-button variant="success" class="mb-2" @click="exportToExcel"
        >تصدير إلى Excel</b-button
      >
    </template>
    <template slot="content">
      <b-table
        :items="items"
        :fields="fields"
        :tbody-transition-props="transProps"
        tbody-tr-class="text-muted"
        responsive
        table-class="table-font h-100"
      >
        <template #cell(id)="data">
          {{ (page - 1) * 10 + data.index + 1 }}
        </template>
        <template v-slot:cell(name)="{ item }">
          <img
            :src="ImageURL(item.visitor)"
            width="35"
            height="35"
            class="bg-info rounded-circle mx-3"
          />
          {{ item.visitor.name }}
        </template>
        <template v-slot:cell(required_period)="{ item }">
          <div class="p-2 rounded-pill green">
            {{ item.required_period }}
            {{ item.required_period > 10 ? " سنوات" : " سنة" }}
          </div>
        </template>
        <template v-slot:cell(salary)="{ item }">
          <div class="p-2 rounded-pill purple">
            {{ parseInt(item.salary) | toCurrency }}
          </div>
        </template>
        <template v-slot:cell(loan_ammount)="{ item }">
          <div class="p-2 rounded-pill purple">
            {{ item.loan_ammount | toCurrency }}
          </div>
        </template>
        <template v-slot:cell(created_at)="{ item }">{{
          new Date(item.created_at).toISOString().slice(0, 10)
        }}</template>
        <template v-slot:cell(actions)="{ item }">
          <b-dropdown size="lg" variant="link" no-caret>
            <template #button-content>
              <b-icon icon="three-dots" animation="cylon"></b-icon>
            </template>
            <b-dropdown-item @click="remove(item.id)">
              <b-icon icon="archive" scale="0.5" class="ml-2"></b-icon>
              حذف</b-dropdown-item
            >
          </b-dropdown>
        </template>
      </b-table>
    </template>
    <template slot="bottom">
      <b-pagination
        v-model="page"
        :current-page="meta.current_page"
        :per-page="meta.per_page"
        :total-rows="meta.last_page * meta.per_page"
      ></b-pagination>
    </template>
  </VContent>
</template>

<script>
import {
  successAlert,
  errorAlert,
  showAlertWithConfirm,
  ImageURL,
} from "@/utils/helper";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export default {
  data() {
    return {
      page: 1,
      readonly: false,
      transProps: {
        name: "flip-list",
      },
      fields: [
        {
          key: "id",
          label: "أ",
          sortable: true,
        },
        {
          key: "name",
          label: "الأسم",
          sortable: true,
        },
        {
          key: "visitor.phone",
          label: "رقم الهاتف",
          sortable: true,
        },
        {
          key: "current_job",
          label: "الوظيفة",
          sortable: true,
        },
        {
          key: "work_location",
          label: "عنوان العمل",
          sortable: true,
        },
        {
          key: "work_start_at",
          label: "تاريخ المباشرة بالوظيفة",
          sortable: true,
        },
        {
          key: "salary",
          label: "الراتب الأسمي",
          sortable: true,
        },
        {
          key: "extra_work",
          label: "الأعمال الاضافية",
          sortable: true,
        },
        {
          key: "contact",
          label: "رقم التواصل البديل",
          sortable: true,
        },
        {
          key: "loan_ammount",
          label: "مبلغ القرض",
          sortable: true,
        },
        {
          key: "required_period",
          label: "مدة التسديد",
          sortable: true,
        },
        {
          key: "created_at",
          label: "تاريخ  الطلب",
          sortable: true,
        },
        {
          key: "actions",
          label: "العمليات",
          sortable: true,
        },
      ],
    };
  },
  computed: {
    items() {
      return this.$store.state.reviewer.requests.loans.list;
    },
    meta() {
      return this.$store.state.reviewer.requests.loans.meta;
    },
  },
  watch: {
    page() {
      this.getAll();
    },
  },
  mounted() {
    this.getAll();
  },
  methods: {
    getAll() {
      this.$store.dispatch("reviewer/requests/loans/get", this.page);
    },
    remove(id) {
      showAlertWithConfirm().then((response) => {
        if (response.isConfirmed) {
          this.$store
            .dispatch("reviewer/requests/loans/delete", id)
            .then(() => {
              successAlert();
              this.$store.commit("reviewer/requests/loans/DELETE_USER", id);
            })
            .catch((error) =>
              errorAlert(
                error.response ? error.response.data.message : "فشل الحذف"
              )
            );
        }
      });
    },
    exportToExcel() {
      // Do not include id, bank, visitor fields in export
      const exportData = this.items.map((item) => {
        const { id, bank, visitor, ...rest } = item;
        return rest;
      });
      const ws = XLSX.utils.json_to_sheet(exportData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "طلبات التقديم على القروض");
      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      saveAs(
        new Blob([wbout], { type: "application/octet-stream" }),
        "loan_requests.xlsx"
      );
    },
    ImageURL(item) {
      return item.image ? item.image : ImageURL("user.jpg");
    },
  },
};
</script>

<style lang="scss">
td[aria-colindex="2"] {
  text-align: right;
}
td[aria-colindex="3"] {
  direction: ltr;
}
</style>
